import {
  SwitchBackground,
  SwitchBorder,
  SwitchCircle,
  SwitchContainer,
  SwitchFakeCheckbox,
  SwitchInput,
} from "src/components/shared/Switch/Switch.components";

interface Props {
  onChange?: () => void;
  value: boolean;
}

const ControlledSwitch: React.FunctionComponent<Props> = ({
  onChange,
  value,
}) => {
  return (
    <SwitchContainer data-cy="switchContainer">
      <SwitchInput type="checkbox" onClick={onChange} />
      <SwitchFakeCheckbox>
        <SwitchBackground isActive={value} />
        <SwitchCircle isActive={value} />
        <SwitchBorder />
      </SwitchFakeCheckbox>
    </SwitchContainer>
  );
};

export default ControlledSwitch;
